module.exports = __webpack_public_path__ + "img/vacation.cbb490a0.jpg";